import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';

export const IntegrationRow = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid ${toColorString(color.base.halfMoon)};

  &:last-child {
    border-bottom: none;
  }
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  color: ${toColorString(color.base.alaskanHusky)};

  &:hover {
    color: ${toColorString(color.status.danger.dark)};
  }
`;
